import React, { useState } from 'react';

import { FeatureCategories } from 'src/modules/designStudio/constants';
import {
  ColorItemType,
  Colors,
} from 'src/modules/designStudio/constants/hardCodedData/colorData';
import { DesignConfig } from 'src/modules/designStudio/types';

import { UpdateDesignFunction } from '../../../../providers/HistoryProvider';
import { ColorPicker } from '../../ColorPicker';

const FILTER_TITLE = 'Colors';

export const ColorList = ({
  color,
  designConfigCategory,
  updateDesign,
  designConfig,
}: {
  color: string | null;
  designConfigCategory: FeatureCategories;
  updateDesign: UpdateDesignFunction;
  designConfig: DesignConfig;
}) => {
  const selectedColor = Colors.find(
    item => item.color === color,
  ) as ColorItemType;
  const initialColorGroup = selectedColor?.group || Colors[0].group;
  const [selectedColorGroup, setColorGroup] = useState(initialColorGroup);
  const changeColor = (newColor: string) => {
    updateDesign({
      category: designConfigCategory,
      update: {
        ...designConfig[designConfigCategory],
        color: newColor,
      },
      trackingData: {
        product: designConfigCategory,
        parameter: FILTER_TITLE,
        selection: newColor,
      },
    });
  };

  const items = Colors.filter(item => item.group === selectedColorGroup);
  const groupSet = new Set<string>();

  Colors.forEach(item => groupSet.add(item.group));

  const groups = Array.from(groupSet);

  return (
    <ColorPicker
      changeColor={changeColor}
      groups={groups}
      items={items}
      selectedColor={selectedColor?.color}
      selectedGroup={selectedColorGroup}
      setColorGroup={setColorGroup}
      title={FILTER_TITLE}
    />
  );
};
